import { useContext, useEffect, useState } from 'react'
import { PRODUCT_MAP } from '../../../../constants/products'
import { SiteConfigContext } from '../../../../context/siteConfigContext'
import { setPageTitle } from '../../../../utils/utilities'
import Free from './Free'
import OpenHouse from './OpenHouse'
import { PRODUCT_ACCESS_MODES } from '@moal/api'

const Product = () => {
  setPageTitle('Configuration | Product')
  const { productsService } = useContext(SiteConfigContext)
  const [current, setCurrent] = useState()

  useEffect(() => {
    if (productsService) {
      setCurrent(productsService[PRODUCT_MAP.THIS_PRODUCT])
    }
  }, [productsService])

  const updateState = (data) => {
    setCurrent(data)
  }

  if (!current) {
    return null
  }

  return (
    <div className="flex flex-col gap-5">
      <h2>Product</h2>
      <OpenHouse product={current} updateState={updateState} />
      {current?.access?.mode === PRODUCT_ACCESS_MODES.FREE && (
        <Free product={current} updateState={updateState} />
      )}
    </div>
  )
}

export default Product
